import { Box, Grid, IconButton, Typography } from "@mui/material";
import React from "react";
import PTIcon from "./PTIcon";
import PTTooltip from "./PTTooltip";
import PTTranslate from "./PTTranslate";
import PTTypography from "./PTTypography";

export const PTFileDisplay = ({
  label,
  fileName,
  isHidden,
  xs = 12,
  md = 6,
  lg = 4,
  gridOptions,
  allowView = () => false,
  doView = () => {},
  ...props
}) => {
  const shouldHide = typeof isHidden === "function" ? isHidden() : isHidden;
  if (shouldHide) return null;
  return (
    <Grid item xs={xs} md={md} lg={lg} {...gridOptions}>
      <div style={{ display: "flex", alignItems: "center", marginLeft: 7 }}>
        <PTTypography
          color="primary"
          style={{
            fontWeight: 550,
            marginRight: 7,
            display: 'inline',
          }}
        >
          <PTTranslate tk={label} /> :
        </PTTypography>

        <Box display="flex" alignItems="center">
          <Typography
            variant="body1"
            color="primary"
            style={{
              display: 'inline',
              wordBreak: "break-word",
            }}
          >
            {fileName || "-"}
          </Typography>
          {fileName && allowView() && <ViewCompoentAnimation doView={doView} />}
        </Box>
      </div>
    </Grid>
  );
};

const ViewCompoentAnimation = ({ doView }) => {
  const [isHovred, setIsHovred] = React.useState(false);
  return (
    <IconButton
      onClick={() => doView()}
      onMouseEnter={() => setIsHovred(true)}
      onMouseLeave={() => setIsHovred(false)}
      sx={{
        ml: "8px",
        p: 0.5, 
        '& svg': {
          width: 25, 
          height: 25, 
          transition: 'transform 0.2s ease',
          transform: isHovred ? 'scale(1.1)' : 'scale(1)', 
        },
        '&:hover': {
          backgroundColor: 'transparent', 
        }
      }}
    >
      <PTIcon
        icon={isHovred ? "view" : "viewClosed"}
        tooltip="view.file"
        sx={{
          color: "#242B59",
          cursor: "pointer"
        }}
      />
    </IconButton>
  );
};

export default PTFileDisplay;
